/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gobackhome2Inputs */

const en_gobackhome2 = /** @type {(inputs: Gobackhome2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back home`)
};

const de_gobackhome2 = /** @type {(inputs: Gobackhome2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Startseite`)
};

/**
* | output |
* | --- |
* | "Go back home" |
*
* @param {Gobackhome2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const gobackhome2 = /** @type {((inputs?: Gobackhome2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gobackhome2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gobackhome2(inputs)
	return de_gobackhome2(inputs)
});
export { gobackhome2 as "goBackHome" }